import './DragableCard.scss';
import Component from './DragableCard';
export default Component;
